import { useMemo } from "react"

import type { useSliderState } from "@unlikelystudio/react-slider"

import type { InferReturn } from "~/@types/generics"

export default function useGetSliderNavigationVisibility({
  slideIndex,
  enableDrag,
  maxSlideIndex,
}: Pick<InferReturn<typeof useSliderState>[0], "slideIndex" | "enableDrag" | "maxSlideIndex">) {
  return useMemo(
    () => ({
      isPrevVisible: enableDrag && slideIndex !== 0,
      isNextVisible: enableDrag && slideIndex < maxSlideIndex,
    }),
    [enableDrag, maxSlideIndex, slideIndex]
  )
}
